/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索：">
        <el-select size="small" v-model="formInline.isLock" placeholder="请选择">
          <el-option label="全部" value=""></el-option>
          <el-option label="正常" value="N"></el-option>
          <el-option label="已锁定" value="Y"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.account" placeholder="输入账号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-s-help" @click="unloadClick">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="userAddress" label="地址" width="300">
        <template slot-scope="scope">
          <div style="cursor: pointer;" @click="copyAddress(scope.row.userAddress)">{{ scope.row.userAddress | plusXing2}}</div>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="bindAddress" label="上级地址" width="300">
        <template slot-scope="scope">
          <div style="cursor: pointer;" @click="copyAddress(scope.row.bindAddress)">{{ scope.row.bindAddress | plusXing2}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="mallAmount" label="可提现GMALL" width="160">
      </el-table-column>
      <el-table-column align="center" sortable prop="mallInput" label="我的算力" width="160">
      </el-table-column>
      <el-table-column align="center" sortable prop="mallTeamScore" label="业绩" width="160">
      </el-table-column>
      <el-table-column align="center" sortable prop="mallLevel" label="等级" width="120">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    
    <!-- 修改资产 -->
    <el-dialog title="修改积分" :visible.sync="dataAccessshow" width="30%" @click='closeDialog("perm")'>
      <el-form label-width="80px">
        <el-form-item label="积分" prop="userBalance">
          <el-input size="small" v-model="userBalance" auto-complete="off" placeholder="请输入需变更的积分余额"></el-input>
        </el-form-item>
        <el-form-item label="选择类型">
          <el-radio-group v-model="canAddTeam" @input="changeRadio">
            <el-radio label="0">修改可用积分</el-radio>
            <el-radio label="1">修改冻结积分</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="seletePswdataShow" width="30%" @click='closeDialog("psw")'>
      <el-form label-width="80px">
          <el-form-item label="密码" prop="userPsw">
            <el-input size="small" v-model="userPsw" auto-complete="off" placeholder="请输入密码"></el-input>
          </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("psw")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="unitPermPswSave">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改层级" :visible.sync="seleteCengShow" width="30%" @click='closeDialog("ceng")'>
      <el-form label-width="80px">
          <el-form-item label="层级" prop="userCeng">
            <el-input size="small" v-model="userCeng" auto-complete="off" placeholder="请输入层级"></el-input>
          </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("ceng")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="unitCengSave">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改代理等级" :visible.sync="seleteLevelShow" width="30%" @click='closeDialog("level")'>
      <el-form label-width="80px">
          <el-form-item label="等级" prop="userLevel">
            <el-input size="small" v-model="userLevel" auto-complete="off" placeholder="请输入代理等级"></el-input>
          </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("level")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="unitLevelSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {
  userDataList,
  adminEatCengImg,
  userPwd,
  adminEatLeveImg,
  userFlashCache,
  userLock,
  userGiveSet,
  exAdminUserAmount,
  UserDeptdeptTree,
  adminUserSet
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import md5 from 'js-md5'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加用户',
      userPsw: '',
      userCeng: '',
      userLevel: '',
      userBalance: '',
      seleteCengShow: false,
      seleteLevelShow: false,
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示
      // 编辑与添加
      editForm: {
        userId: '',
        userName: '',
        userRealName: '',
        roleId: '',
        userMobile: '',
        userEmail: '',
        userSex: '',
        token: localStorage.getItem('logintoken')
      },
      // 部门参数
      unitparm: {
        userIds: '',
        deptId: '',
        deptName: ''
      },
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        userRealName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        roleId: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        userMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
            required: true,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 删除用户
      seletePswdataShow: false,
      // 重置密码
      resetpsd: {
        userId: ''
      },
      // 用户下线
      offline: {
        token: localStorage.getItem('logintoken')
      },
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10,
        account: '',
      },
      canAddTeam: '',
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      saveroleCengId: '',
      saveroleLevelId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  filters: {
    plusXing2(str) {
				if (str.length == 0) {
					return "";
				}
				var len = str.length - 4;
				var xing = '';
				for (var i = 0; i < 10; i++) {
					xing += '*';
				}
				return str.substring(0, 6) + xing + str.substring(str.length - 6);
			}
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      userDataList(parameter).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.userData = res.data
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.num
        }
      })
    },
    copyAddress(val) {
      this.$copyText(val.replace(/( |null)/g, '')).then(
        (e) => {
          this.$message.success('复制成功!')
          console.log(e);
        },
        (err) => {
          this.$message.error('复制失败,请重试!')
          console.log(err);
        }
      );
    },
    changeRadio(e) {
      this.canAddTeam = e;
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    unloadClick() {
      this.formInline = {
        page: 1,
        limit: 10,
        account: '',
      }
      this.getdata(this.formInline)
    },
    // 修改type
    editType: function(index, row) {
      this.loading = true
      let parm = {
        lock: '',
        userId: '',
        token: localStorage.getItem('logintoken')
      }
      parm.userId = row.userId
      let lock = row.isLock
      if (lock == 'N') {
        parm.lock = 'Y'
      } else {
        parm.lock = 'N'
      }
      // 修改状态
      userLock(parm).then(res => {
        this.loading = false
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'success',
            message: '状态修改成功'
          })
          this.getdata(this.formInline)
        }
      })
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改用户'
        this.editForm.userId = row.userId
        this.editForm.userName = row.userName
        this.editForm.userRealName = row.userRealName
        this.editForm.roleId = row.roleId
        this.editForm.userMobile = row.userMobile
        this.editForm.userEmail = row.userEmail
        this.editForm.userSex = row.userSex
      } else {
        this.title = '添加用户'
        this.editForm.userId = ''
        this.editForm.userName = ''
        this.editForm.userRealName = ''
        this.editForm.roleId = ''
        this.editForm.userMobile = ''
        this.editForm.userEmail = ''
        this.editForm.userSex = ''
      }
    },
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.unitparm.deptId = data.id
        this.unitparm.deptName = data.name
        //交叉点击节点
      } else {
      }
    },
    unitLevelSave() {
      this.loading = true
      adminEatLeveImg({userId:this.saveroleLevelId,agentLevel:this.userLevel})
        .then(res => {
          if (res.success) {
            this.loading = false
            this.seleteLevelShow = false
            this.$message({
              type: 'success',
              message: '代理等级设置成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('请稍后再试！')
        })
    },
    unitCengSave() {
      this.loading = true
      adminEatCengImg({userId:this.saveroleCengId,eatCount:this.userCeng})
        .then(res => {
          if (res.success) {
            this.loading = false
            this.seleteCengShow = false
            this.$message({
              type: 'success',
              message: '层级设置成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('请稍后再试！')
        })
    },
    unitPermPswSave() {
      this.loading = true
      adminUserSet({psw:md5(userPsw),userId:this.resetpsd.userId})
        .then(res => {
          if (res.success) {
            this.loading = false
            this.seletePswdataShow = false
            this.$message({
              type: 'success',
              message: '密码设置成功！'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('请稍后再试！')
        })
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      } else if(dialog == 'psw'){
        this.seletePswdataShow = false;
      } else if(dialog == 'ceng') {
        this.seleteCengShow = false;
      } else if(dialog == 'level') {
        this.seleteLevelShow = false;
      }
    },
    // 封禁用户
    deleteUser(val, row) {
      this.$confirm('确定' + row.account + '用户吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          adminUserSet({userId:row.id,status:val})
            .then(res => {
              if (res.success) {
                if(val == 1) {
                  this.$message({
                    type: 'success',
                    message: '用户' + row.account + '封禁成功！'
                  })
                } else{
                  this.$message({
                    type: 'success',
                    message: '用户' + row.account + '解封成功！'
                  })
                }
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 重置密码
    resetpwd(index, row) {
      this.resetpsd.userId = row.id
      this.seletePswdataShow = true
    },
    // 数据权限
    dataAccess: function(index, row) {
      this.dataAccessshow = true
      this.saveroleId = row.id
    },
    exchangeCeng(index, row) {
      this.seleteCengShow = true
      this.saveroleCengId = row.id
    },
    exchangeLevel(index, row) {
      this.seleteLevelShow = true
      this.saveroleLevelId = row.id
    },
    menuPermSave() {
      this.loading = true
      exAdminUserAmount({userId:this.saveroleId,amount:this.userBalance,exType:this.canAddTeam})
        .then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '积分修改成功'
            })
            this.loading = false
            this.dataAccessshow = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('请稍后再试！')
        })
    },
    offlineUser(index, row) {
      this.$confirm('确定要让' + row.account + '用户获得签到奖励吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          userGiveSet({userId:row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '用户' + row.account + '获得签到奖励成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/user.vue